export const MESSAGES_RETRIEVE_BACKWARD_REQUESTED = 'MESSAGES_RETRIEVE_BACKWARD_REQUESTED';
export const MESSAGES_RETRIEVE_BACKWARD_SUCCEED = 'MESSAGES_RETRIEVE_BACKWARD_SUCCEED';
export const MESSAGES_RETRIEVE_BACKWARD_FAILED = 'MESSAGES_RETRIEVE_BACKWARD_FAILED';

export const MESSAGES_RETRIEVE_FORWARD_REQUESTED = 'MESSAGES_RETRIEVE_FORWARD_REQUESTED';
export const MESSAGES_RETRIEVE_FORWARD_SUCCEED = 'MESSAGES_RETRIEVE_FORWARD_SUCCEED';
export const MESSAGES_RETRIEVE_FORWARD_FAILED = 'MESSAGES_RETRIEVE_FORWARD_FAILED';

export const MESSAGES_RETRIEVE_GOTO_TIME_SUCCEED = 'MESSAGES_RETRIEVE_GOTO_TIME_SUCCEED';
export const MESSAGES_RETRIEVE_GOTO_TIME_REQUESTED = 'MESSAGES_RETRIEVE_GOTO_TIME_REQUESTED';
export const MESSAGES_RETRIEVE_GOTO_TIME_FAILED = 'MESSAGES_RETRIEVE_GOTO_TIME_FAILED';

export const MESSAGE_RECEIVED = 'MESSAGE_RECEIVED';
export const MESSAGE_ADD_NEW = 'MESSAGE_ADD_NEW';

export const MESSAGES_CLEAR = 'MESSAGES_CLEAR';

export const MESSAGES_SEARCH_REQUESTED = 'MESSAGES_SEARCH_REQUESTED';
export const MESSAGES_SEARCH_SUCCEED = 'MESSAGES_SEARCH_SUCCEED';
export const MESSAGES_SEARCH_FAILED = 'MESSAGES_SEARCH_FAILED';

export const MESSAGES_SEARCH_LOAD_MORE_REQUESTED = 'MESSAGES_SEARCH_LOAD_MORE_REQUESTED';
export const MESSAGES_SEARCH_LOAD_MORE_SUCCEED = 'MESSAGES_SEARCH_LOAD_MORE_SUCCEED';
export const MESSAGES_SEARCH_LOAD_MORE_FAILED = 'MESSAGES_SEARCH_LOAD_MORE_FAILED';

export const MESSAGES_READ_TIME_UPDATE_REQUESTED = 'MESSAGES_READ_TIME_UPDATE_REQUESTED';
export const MESSAGES_READ_TIME_UPDATE_SUCCEED = 'MESSAGES_READ_TIME_UPDATE_SUCCEED';
export const MESSAGES_READ_TIME_UPDATE_FAILED = 'MESSAGES_READ_TIME_UPDATE_FAILED';

export const MESSAGES_DOCTOR_BACKWARD_REQUESTED = 'MESSAGES_DOCTOR_BACKWARD_REQUESTED';
export const MESSAGES_DOCTOR_BACKWARD_SUCCEED = 'MESSAGES_DOCTOR_BACKWARD_SUCCEED';
export const MESSAGES_DOCTOR_BACKWARD_FAILED = 'MESSAGES_DOCTOR_BACKWARD_FAILED';

export const MESSAGES_REQUEST_POOL_REQUESTED = 'MESSAGES_REQUEST_POOL_REQUESTED';
export const MESSAGES_REQUEST_POOL_SUCCEED = 'MESSAGES_REQUEST_POOL_SUCCEED';
export const MESSAGES_REQUEST_POOL_FAILED = 'MESSAGES_REQUEST_POOL_FAILED';

export const MESSAGES_READ_REQUESTED = 'MESSAGES_READ_REQUESTED';
export const MESSAGES_READ_SUCCEED = 'MESSAGES_READ_SUCCEED';
export const MESSAGES_READ_FAILED = 'MESSAGES_READ_FAILED';

export const ADD_BUBBLE_MESSAGE_REQUESTED = 'ADD_BUBBLE_MESSAGE_REQUESTED';
export const ADD_BUBBLE_MESSAGE_SUCCEED = 'ADD_BUBBLE_MESSAGE_SUCCEED';
export const ADD_BUBBLE_MESSAGE_FAILED = 'ADD_BUBBLE_MESSAGE_FAILED';
export const MESSAGE_SET_JUMP_MESSAGE = 'MESSAGE_SET_JUMP_MESSAGE';

export const CONVERSATION_CLEAR_MESSAGES = 'CONVERSATION_CLEAR_MESSAGES';
export const MESSAGE_REMOVE_BY_ID = 'MESSAGE_REMOVE_BY_ID';
